import { render } from "./histogram.vue?vue&type=template&id=90eab5a4"
import script from "./histogram.vue?vue&type=script&lang=js"
export * from "./histogram.vue?vue&type=script&lang=js"

import "./histogram.vue?vue&type=style&index=0&id=90eab5a4&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__